import PropTypes from "prop-types";
import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import {
  ResultState,
  ResultIcon,
  ResultTitle,
  ResultMessage,
} from "app/components/DialogFrame/styles";
import { PrimaryButton } from "app/components/DialogFooterButtons/styles";

// Jussub plans don't have gateway_id, only Jusbill.
// Fallback to validate only id when gateway_id doesn't exist.
const isSelectedPlanInCatalog = (plans, selectedPlan) =>
  plans.some(plan => {
    if (plan.id !== selectedPlan?.id) return false;
    if (plan.gateway_id == null || selectedPlan?.gateway_id == null) {
      return true;
    }
    return Number(plan.gateway_id) === Number(selectedPlan.gateway_id);
  });

const CadastroPlanGate = ({
  isPricingResolved,
  isError,
  onRetry,
  plans,
  selectedPlan,
  hasValidCoupon,
  children,
}) => {
  if (isError) {
    const errorNotice = (
      <ResultState role="alert">
        <ResultIcon $variant="error">
          <ErrorOutlineIcon />
        </ResultIcon>
        <ResultTitle>Não foi possível carregar os planos</ResultTitle>
        <ResultMessage>
          Tente novamente em instantes ou entre em contato com o suporte.
        </ResultMessage>
        <PrimaryButton type="button" onClick={onRetry}>
          Tentar novamente
        </PrimaryButton>
      </ResultState>
    );

    // campo de cupom (dentro de children) não pode desmontar num erro
    // bloqueante do catálogo — sobrepõe o aviso em vez de substituir, mantendo o campo acessível
    // pra editar/remover o cupom sem reload, mesmo quando o erro não é sobre cupom.
    return (
      <>
        {errorNotice}
        {children}
      </>
    );
  }

  const isReady =
    isPricingResolved &&
    plans.length > 0 &&
    (hasValidCoupon || isSelectedPlanInCatalog(plans, selectedPlan));

  if (!isReady) {
    return (
      <div
        role="status"
        aria-live="polite"
        aria-busy="true"
        className="py-10 text-center"
      >
        Carregando planos...
      </div>
    );
  }

  return children;
};

CadastroPlanGate.propTypes = {
  isPricingResolved: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  onRetry: PropTypes.func,
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      gateway_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
  selectedPlan: PropTypes.shape({
    id: PropTypes.string,
    gateway_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  hasValidCoupon: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

CadastroPlanGate.defaultProps = {
  isError: false,
  onRetry: null,
  selectedPlan: null,
  hasValidCoupon: false,
};

export default CadastroPlanGate;
